import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "@/i18n/resource";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "jp",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  }).then();


export default i18n;
